module.exports = __webpack_public_path__ + "img/logo.02780b61.svg";